import * as React from 'react';
import { Box, Collapse, Alert as MAlert, Typography } from '@mui/material';
import { CampaignOutlined, Close } from '@mui/icons-material';
import { IconButton } from '../IconButton';

type SystemNoteItemProps = {
  title: string;
  message: string;
  isHTML: boolean;
};

export const SystemNoteItem: React.FunctionComponent<SystemNoteItemProps> = (
  props: SystemNoteItemProps,
) => {
  const [open, setOpen] = React.useState(true);
  const { title, message, isHTML } = props;
  return (
    <Collapse in={open}>
      <MAlert
        icon={false}
        sx={{
          bgcolor: '#EBE0E0',
          paddingY: '0.5em',
          paddingLeft: '3em',
          borderRadius: 0,
        }}
        action={
          <IconButton
            aria-label="close"
            size="small"
            color="primary"
            onClick={() => {
              setOpen(false);
            }}
            icon={<Close fontSize="inherit" />}
          />
        }
      >
        <Box
          display={'Flex'}
          flexDirection={'row'}
          justifyContent={'flex-start'}
          alignItems={'center'}
        >
          <CampaignOutlined sx={{ mr: 1 }} color="primary" />
          <Typography fontSize={'14px'} color={'#951D1D'} fontWeight={700}>
            {title}
          </Typography>
        </Box>
        {isHTML ? (
          <div
            style={{
              fontSize: '13px',
              paddingLeft: '2.5em',
              color: '#000000',
              fontWeight: 500,
            }}
            dangerouslySetInnerHTML={{
              __html: message,
            }}
          />
        ) : (
          <Typography fontSize={'13px'}>{message}</Typography>
        )}
      </MAlert>
    </Collapse>
  );
};
